var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._m(0),_c(_setup.ListaCarteiras,{staticClass:"px-5"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center px-2 py-1 bg-gray-100"},[_c('span',{staticClass:"ma-2 ml-4 font-16 font-weight-medium"},[_vm._v("\n      CARTEIRA DE COMPRAS\n    ")])])
}]

export { render, staticRenderFns }